import {loadAuditEntity,loadAuditRecords} from '../../constants/apiConst';
import {Post} from '../../modules/apis/apiUtitlity';

export async function fetchAuditEntity(payLoad) {
    return await Post(loadAuditEntity.subUri, {}, {...payLoad});
}
export async function fetchAuditData(payLoad) {
    return await Post(loadAuditRecords.subUri, {}, {...payLoad});
}